import BackButton from 'components/BackButton';
import InvoicePosting from 'components/InvoicePosting';
import PageContainer from 'components/PageContainer';
import React from 'react';

import { SectionContainer } from './styles';

const PostingInvoices: React.FC = () => {
  return (
    <PageContainer>
      <BackButton />
      <SectionContainer testID="sectionPosting">
        <InvoicePosting title="Lançamentos da fatura" showAllPurchases />
      </SectionContainer>
    </PageContainer>
  );
};

export default PostingInvoices;
